<template>
 <div class="">
    <div class="skeleton" v-if="skeleton"></div>
    <div v-if="filters">
        <div class="drop_block" v-show="!skeleton && filters" tabindex="0" @focusout="openDropDown = false">
            <div class="drop_box" @click="openDropDown = !openDropDown">
                <div class="drop_name">
                    {{label}} 
                    <span class="active_count">:  {{currentActive}}</span>
                </div>
                <div class="drop_arrow">
                    <SvgHeaderSvg v-if="openDropDown" :type="'up'" />
                    <SvgHeaderSvg v-else :type="'down'" />
                </div>
            </div>
            <div v-show="openDropDown" class="drop_item" :class="'drop_item_'+label">
                <ul class="mb-0">
                    <li 
                        v-for="filter in filters" :key="filter.value" 
                        :class="{'active': filter.active}"
                        @click="selectOption(filter.value)" 
                    >
                        <span>{{ filter.label }}</span>
                    </li>
                </ul>    
            </div>
    </div>
</div>
</div>

</template>

<script setup>

const props = defineProps({
  filters: Array,
  label: String,
});

const showOptions = ref(false);
// const selected = ref('');
const skeleton = ref(false);

const openDropDown = ref(false)

const emit = defineEmits(['selectOption']);

const currentActive = computed(() => {
  let value = '';
  props.filters.find((cv) => {
    if (cv.active) {
      value = cv.label;
    }
  });
  return value;
});

const selectOption = (value) => {
  props.filters.filter((item) => {
    if(item.value === value) {
        item.active = true
    }
    else{item.active = false}
  });
  showOptions.value = false;
  openDropDown.value=false
  emit('selectOption');
};


</script>



<style scoped>
    .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
    .drop_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #c4c4c4;
        border-radius: 8px;
        padding: 8px 12px;
        cursor: pointer;
    }
    .drop_name {
        margin-right: 8px;
        font-size: 14px;
        text-transform: capitalize;
        font-weight: 400;
        color: #212529;
    }
    .drop_name .active_count{
        color: var(--green);
    }
    .drop_item{
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        position: absolute;
        top: 100%;
        background: #fff;
        left: 0;
        z-index: 99;
        min-width: 200px;
    }
    .drop_item.drop_item_shape {
        width: 315px;
    }
    .title_close {
        padding: 15px 15px 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title_close .title {
        font-size: 14px;
        text-transform: capitalize;
        font-weight: 700;
        color: #000;
        display: flex;
        align-items: center;
    }
    /* .eclipse {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 140px;
    } */
    .close {
        cursor: pointer;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 8px 8px 8px;
    }
    ul li {
        list-style: none;
        width: 100%;
        border-radius: 8px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin: 5px;
        cursor: pointer;
    }
   
    ul li.active span{
        color: var(--green);
        font-weight: 600;
    }
 
  
    .drop_block {
        position: relative;
        min-width: 200px;
    }

    ul li span {
        text-transform: capitalize;
        font-size: 13px;
        font-weight: 400;
        color: #606060;
        display: block;
    }
    .active_label{
        color: var(--green);
    }
    .svg-head {
        height: 17px;
        width: 20px;
    }
    @media(max-width: 767px){
        /* ul{
            width: 100%;
        } */
        .drop_block {
            min-width: auto;
        }
        .drop_box {
            border: 0;
            padding: 0;
        }

        /* .drop_name {
            font-weight: 400;
        } */
    }
</style>